"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableLanguages = exports.intl = void 0;
const react_intl_1 = require("react-intl");
const Redux_1 = require("./Redux");
const intlCache = (0, react_intl_1.createIntlCache)();
const getIntlConfig = (locale, messages) => ({
    locale,
    defaultLocale: Redux_1.AvailableLanguagesExtended.DeDE,
    messages,
});
const intl = (locale, messages) => (0, react_intl_1.createIntl)(getIntlConfig(locale, messages), intlCache);
exports.intl = intl;
const availableLanguages = (messages) => [
    {
        name: 'Deutsch',
        enabled: true,
        extendedCode: Redux_1.AvailableLanguagesExtended.DeDE,
        code: Redux_1.AvailableLanguages.De,
        intl: (0, exports.intl)(Redux_1.AvailableLanguagesExtended.DeDE, messages.de),
        intlConfig: getIntlConfig(Redux_1.AvailableLanguagesExtended.DeDE, messages.de),
    },
    {
        name: 'English',
        enabled: true,
        extendedCode: Redux_1.AvailableLanguagesExtended.En150,
        code: Redux_1.AvailableLanguages.En,
        intl: (0, exports.intl)(Redux_1.AvailableLanguagesExtended.En150, messages.en),
        intlConfig: getIntlConfig(Redux_1.AvailableLanguagesExtended.En150, messages.en),
    },
    {
        name: 'Shqip',
        enabled: true,
        extendedCode: Redux_1.AvailableLanguagesExtended.SqAL,
        code: Redux_1.AvailableLanguages.Sq,
        intl: (0, exports.intl)(Redux_1.AvailableLanguagesExtended.SqAL, messages.sq),
        intlConfig: getIntlConfig(Redux_1.AvailableLanguagesExtended.SqAL, messages.sq),
    },
];
exports.availableLanguages = availableLanguages;
